import styled from 'styled-components';
import { rem } from 'polished';
import { breakpoints } from '@theme/breakpoints';

export default styled.div`
  padding-right: ${rem(16)};
  padding-bottom: ${rem(5)};
  @media ${breakpoints.mobilelgMax} {
    text-align: center;
    padding-right: 0;
  }
  & > h2 {
    color: #fff;
    font-family: var(--font-geomanist);
    font-weight: 700;
    font-size: 27px;
    line-height: 100%;
    letter-spacing: 0;
    text-align: center;
  }
  & > p {
    color: #fff;
    font-family: var(--font-geomanist);
    font-weight: 200;
    font-size: 18px;
    line-height: 100%;
    letter-spacing: 0;
    text-align: center;
  }
`;
